import styles from '../App.module.css'
export default function DashLayoutFooter() {
    return (
        <div className={styles.center}>
            <p>All right reserved - 2022</p>
        </div>
    )
}
